<template>
  <div class="pagesearch">
    <div style="position: fixed;top:0;z-index:999999;width: 100%;height: 1rem;background-color: white">
      <div style="width: 90%;margin-left: 5%">
        <md-input-item ref="input11" v-model="keyword" @blur="getlist(null)" placeholder="快遞單號">
          <md-icon name="search" slot="left" @click.native="getlist(null)"></md-icon>
          <span slot="right" @click="cancel">取消</span>
        </md-input-item>
      </div>
    </div>
    <div style="width: 100%;height: 1rem"></div>
    <v-refresh :on-refresh="onRefreshone">
      <v-reload :on-infinite-load="infinite" :parent-pull-up-state="infiniteLoadData.pullUpState">
        <div v-if="list.length > 0" class="packcontainer">
          <div v-for="(item, index) in list" :key="index" class="packItem">
            <div class="packcompany">
              <div class="packtitle">
                <img src="@/assets/image/icon_pack_drk.png" alt="" v-if="item.type == 0">
                <div class="packageTyp" v-if="item.type == 1">
                  <span>特</span>
                </div>
                <span>{{ item.warehouse }}</span>
              </div>
              <span v-if="item.status < 11">待入庫</span>
              <span v-if="item.status == 11" style="color: #32c5ea">待補資料</span>
              <span v-if="item.status == 12">待合包</span>
              <span v-if="item.status == 13" style="color: #e51c23">超期</span>
              <span v-if="item.status == 14" style="color: #32c5ea">待補資料</span>
              <span v-if="item.status == 21" style="color: #e51c23">[拒收]尺寸超标</span>
              <span v-if="item.status == 22" style="color: #e51c23">[拒收]包裹超重</span>
              <span v-if="item.status == 23" style="color: #e51c23">[拒收]违禁物品</span>
              <span v-if="item.status == 24" style="color: #e51c23">[拒收]涉嫌侵权</span>
              <span v-if="item.status == 31" style="color: #e51c23">已合包</span>
              <span v-if="item.status == 32" style="color: #e51c23">已销毁</span>
              <span v-if="item.status == 33" style="color: #e51c23">退货中</span>
              <span v-if="item.status == 34" style="color: #e51c23">退货完成</span>
            </div>
            <md-button type="warning" plain v-if="item.status == 11 || item.status == 14"
              style="width: 90%;height: 0.7rem;margin: 0.2rem 5%" icon="info" @click="godetail(item)">點擊進入補全商品資訊及價值
            </md-button>
            <div class="pckdetail" v-if="item.status < 11">
              <p>快遞單號：<span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                <span v-else>{{ item.expressNumber }}</span>
              </p>
              <p>包裹總值：
                <md-amount :value="item.totalPrice" has-separator></md-amount>
                CNY
              </p>
              <p>預報時間：<span>{{ item.createTime | dateformat('YYYY-MM-DD HH:mm') }}</span></p>
            </div>
            <div class="pckdetail" @click="godetail(item)" v-if="item.status >= 11 && item.status <= 14">
              <p>快遞單號：<span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                <span v-else>{{ item.expressNumber }}</span>
              </p>
              <p>計費重：<md-amount :value="item.weight" has-separator style="margin-left: 0.7rem"></md-amount> KG</p>
              <p>入庫時間：<span>{{ item.deliveryTime | dateformat('YYYY-MM-DD HH:mm') }}</span></p>
              <p v-if="item.auditStatus == 0">審核狀態：<span style="color: red">待審核</span></p>
            </div>
            <div class="pckdetail" @click="godetail(item)" v-if="item.status >= 21 && item.status <= 24">
              <p>快遞單號：<span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                <span v-else>{{ item.expressNumber }}</span>
              </p>
              <p>計費重：<md-amount :value="item.weight" has-separator style="margin-left: 0.7rem"></md-amount> KG</p>
              <p>拒收時間：<span>{{ item.deliveryTime | dateformat('YYYY-MM-DD HH:mm') }}</span></p>
              <p v-if="item.auditStatus == 0">審核狀態：<span style="color: red">待審核</span></p>
            </div>
            <div class="pckdetail" @click="godetail(item)" v-if="item.status > 24">
              <p>快遞單號：<span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                <span v-else>{{ item.expressNumber }}</span>
              </p>
              <p>計費重：<md-amount :value="item.weight" has-separator style="margin-left: 0.7rem"></md-amount> KG</p>
              <p v-if="item.status < 21 || item.status > 24">入庫時間：
                <span>{{ item.deliveryTime | dateformat('YYYY-MM-DD HH: mm') }}</span>
              </p>
              <p v-if="item.status >= 21 && item.status <= 24">拒收時間：
                <span>{{ item.deliveryTime | dateformat('YYYY-MM-DD HH: mm') }}</span>
              </p>
              <p>合包時間：<span>{{ item.updateTime | dateformat('YYYY-MM-DD HH:mm') }}</span></p>
            </div>
            <div class="packopeartion" v-if="item.status < 11">
              <md-button type="primary" size="small" inline plain @click="detail(item)" round>編輯</md-button>
              <md-button type="warning" size="small" inline plain style="margin-left: 0.2rem"
                @click="delet(item, index)" round>删除
              </md-button>
              <md-button type="default" size="small" inline plain style="margin:0 0.2rem" @click="lookwu(item)"
                round>查看物流
              </md-button>
              <md-button type="primary" size="small" inline plain @click="chenkjfr(item)" v-if="item.status == 2" round
                style="margin-right: 0.2rem">撤銷拒收</md-button>
              <md-button type="primary" size="small" inline plain @click="lanjie(item)"
                v-if="item.status == 1 || item.status == 3" round style="margin-right: 0.2rem">拒收攔截</md-button>
            </div>
            <div class="packopeartion" v-if="item.status >= 11 && item.status <= 14">
              <md-button type="default" size="small" inline plain style="margin:0 0.2rem" @click="returnpack(item)"
                round>退貨
              </md-button>
            </div>
            <div class="packopeartion" v-if="item.status > 14" style="height: 0.4rem"></div>
          </div>
        </div>
        <noth-modal v-else></noth-modal>
        <div style="width: 100%;height: 2rem"></div>
      </v-reload>
    </v-refresh>
  </div>
</template>

<script>
import { Amount, Button, Dialog, Field, Icon, InputItem, TabPane, Tabs, Toast } from 'mand-mobile'
import DropDownRefresh from '../../components/refresh'
import PullUpReload from '../../components/pullDown'
import NothModal from '../Modal/NothModal'

export default {
  name: 'packSearch',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [Amount.name]: Amount,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    // eslint-disable-next-line vue/no-unused-components
    'v-refresh': DropDownRefresh,
    // eslint-disable-next-line vue/no-unused-components
    'v-reload': PullUpReload,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data() {
    return {
      infiniteLoadData: {
        initialShowNum: 5, // 初始显示多少条
        everyLoadingNum: 5, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },
      pagenum: 1,
      keyword: '',
      list: []
    }
  },
  activated() {
    if (localStorage.getItem('serfren')) {
      if (localStorage.getItem('fleshpack')) {
        this.getlist(null)
      }
    } else {
      this.list = []
      this.pagenum = []
      this.keyword = ''
      this.infiniteLoadData.pullUpState = 0
      this.infiniteLoadData.pullUpList = []
    }
  },
  methods: {
    cancel() {
      this.keyword = ''
      this.$router.go(-1)
    },
    returnpack(item) {
      localStorage.setItem('serfren', '2122')
      this.$router.push({
        name: 'ReturnAddress',
        query: {
          des: JSON.stringify(item)
        }
      })
    },
    getvalue() {
      console.log(this.keyword)
    },
    lookwu(item) {
      localStorage.setItem('serfren', '2122')
      this.$router.push({
        name: 'PackLogin',
        query: {
          expressNumber: item.expressNumber,
          expressCompany: item.expressCompany
        }
      })
    },
    lanjie(item) {
      Dialog.confirm({
        content: '通知倉庫攔截並拒收該包裹，是否確認操作？',
        confirmText: '確定',
        onConfirm: () => this.parcelRejection(item.id)
      })

    },
    chenkjfr(item) {
      Dialog.confirm({
        content: '撤銷後包裹可以正常入庫，確定撤銷此拒收嗎？',
        confirmText: '確定',
        onConfirm: () => this.parcelCancelRejection(item.id)
      })
    },
    parcelCancelRejection(id) {
      const par = {
        id: id
      }
      this.http.APIASK(this.ports.parcelCancelRejection, 'get', par).then(res => {
        this.getlist(null)
      }).catch(err => {
        Toast.hide()
      })
    },
    parcelRejection(id) {
      const par = {
        id: id
      }
      this.http.APIASK(this.ports.parcelRejection, 'get', par).then(res => {
        this.getlist(null)
      }).catch(err => {
        Toast.hide()
      })
    },
    getlist(opear) {
      this.infiniteLoadData.pullUpState = 2
      const par = {
        keyword: this.keyword.replace(/\s+/g, ''),
        pageNum: this.pagenum,
        pageSize: 5,
        sort: false
      }
      this.http.APIASK(this.ports.parcelsearch, 'get', par).then(res => {
        if (opear) {
          if (res.list.length > 0) {
            this.list = this.list.concat(res.list)
            this.infiniteLoadData.pullUpList = this.list
            if (res.list.length < 5) {
              this.infiniteLoadData.pullUpState = 3
            } else {
              this.infiniteLoadData.pullUpState = 1
            }
          } else {
            this.infiniteLoadData.pullUpState = 3
          }
        } else {
          if (res.list.length < 5) {
            this.infiniteLoadData.pullUpState = 3
          } else {
            this.infiniteLoadData.pullUpState = 1
          }
          this.list = res.list
          this.infiniteLoadData.pullUpList = this.list
        }
        this.list.length < 3 ? this.infiniteLoadData.pullUpState = 0 : null
        Toast.hide()
      }).catch(err => {
        Toast.hide()
      })
    },
    delet(item, indx) {
      Dialog.confirm({
        content: '您確定要删除該包裹嗎',
        confirmText: '確定',
        onConfirm: () => {
          const par = {
            id: item.id
          }
          this.http.APIASK(this.ports.parceldelete, 'delete', par).then(res => {
            this.getlist(null)
            Toast.succeed('删除成功')
          }).catch(err => {
          })
        }
      })
    },
    godetail(item) {
      localStorage.setItem('serfren', '2122')
      this.$router.push({ name: 'Packdetail', query: { id: item.id, status: item.status } })
    },
    detail(item) {
      localStorage.setItem('serfren', '2122')
      this.$router.push({ name: 'Predition', query: { id: item.countryId, item: JSON.stringify(item) } })
    },
    onRefreshone(done) {
      setTimeout(() => {
        this.infiniteLoadData.pullUpList = []
        this.pagenum = 1
        this.getlist(null)
        done()
      }, 500)
    },
    onClick() {

    },
    infinite(done) {
      console.log(this.infiniteLoadData.pullUpState)
      if (this.infiniteLoadData.pullUpState === 1) {
        setTimeout(() => {
          this.pagenum++
          this.getlist('load')
          done()
        }, 500)
      } else {
        done()
        this.infiniteLoadData.pullUpState = 0
      }
    }
  }
}
</script>

<style lang="less">
.pagesearch {
  .packcontainer {
    margin-top: 0.2rem;
  }

  .packItem {
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
    margin-bottom: 0.2rem;
    border-radius: 0.1rem;
    width: 94%;
    margin-left: 3%;

    .packcompany {
      width: 100%;
      height: 0.8rem;
      display: flex;
      align-items: center;
      font-size: 0.32rem;
      justify-content: space-between;
      border-bottom: 1px solid #e2e4ea;

      .packtitle {
        height: 100%;
        display: flex;
        align-items: center;

        img {
          width: 0.5rem;
          margin: 0 0.2rem;
        }
      }

      span {
        margin-right: 0.2rem;
      }
    }

    .pckdetail {
      width: 100%;
      padding-left: 0.2rem;
      font-size: 0.3rem;

      p {
        text-align: left;
        margin: 0.2rem 0;

        span {
          margin-left: 0.4rem;
        }
      }
    }

    .packopeartion {
      width: 100%;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .packageTyp {
    padding: 0.04rem 0.11rem;
    border-radius: 0.07rem;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(82, 204, 111, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.2rem;

    span {
      margin: 0 !important;
    }
  }

  .checkbtn {
    margin-left: 0.2rem;

    .md-check-icon {
      font-size: 0.8rem;
    }
  }

  .bottomView {
    position: fixed;
    width: 100%;
    height: 1.2rem;
    bottom: 1rem;
    background-color: red;
  }

}
</style>
